import { Link } from 'react-router-dom';

const DELIVERY_ZONES = 'Mississauga, Brampton, Oakville, Milton, Downtown Toronto, Scarborough, Etobicoke, Vaughan, Newmarket, Ajax, Oshawa, Pickering, Markham, Kitchener, Guelph';

export function Footer() {
  return (
    <footer
      className="pt-12 pb-8 mt-auto font-body"
      style={{ backgroundColor: '#243C7B', color: 'white' }}
    >
      <div className="container mx-auto px-4 grid md:grid-cols-3 gap-8 mb-8 text-center md:text-left">
        {/* Column 1: Contact Us */}
        <div>
          <h3 className="font-heading font-bold text-xl mb-4 text-terracotta">Contact Us</h3>
          <p className="mb-2">
            <span className="font-semibold">Email:</span>{' '}
            <a
              href="mailto:proteinmealsinc@gmail.com"
              className="hover:text-[#F7DFA1] transition-colors"
            >
              proteinmealsinc@gmail.com
            </a>
          </p>
          <p className="mb-2">
            <span className="font-semibold">WhatsApp:</span>{' '}
            <a
              href="https://wa.me/14376169335"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#F7DFA1] transition-colors"
            >
              +1 437 616 9335
            </a>
          </p>
        </div>

        {/* Column 2: Delivery Zones */}
        <div>
          <h3 className="font-heading font-bold text-xl mb-4 text-terracotta">Delivery Zones</h3>
          <p className="text-sm leading-relaxed opacity-90">
            {DELIVERY_ZONES}
          </p>
        </div>

        {/* Column 3: Quick Links */}
        <div>
          <h3 className="font-heading font-bold text-xl mb-4 text-terracotta">Quick Links</h3>
          <ul className="space-y-2">
            <li><Link to="/" className="hover:text-[#F7DFA1] transition-colors">Home</Link></li>
            <li><Link to="/menu" className="hover:text-[#F7DFA1] transition-colors">Menu</Link></li>
            <li><Link to="/plans" className="hover:text-[#F7DFA1] transition-colors">Plans</Link></li>
            <li><Link to="/account" className="hover:text-[#F7DFA1] transition-colors">Dashboard</Link></li>
            <li><Link to="/blog" className="hover:text-[#F7DFA1] transition-colors">Blog</Link></li>
            <li><Link to="/faq" className="hover:text-[#F7DFA1] transition-colors">FAQ</Link></li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar: Copyright & Legal */}
      <div className="container mx-auto px-4">
        <div className="border-t border-white/10 pt-6 text-center text-xs opacity-60 flex flex-col md:flex-row justify-between items-center gap-4">
          <p>&copy; {new Date().getFullYear()} ProteinMeals. All rights reserved.</p>
          <div className="flex gap-4">
            <Link to="/terms" className="hover:text-white transition-colors">Terms &amp; Conditions</Link>
            <Link to="/shipping-policy" className="hover:text-white transition-colors">Shipping Policy</Link>
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
